
export default {
  props: {
    icon: {type: String, required: true},
    size: {type: String, default: '2rem'},
    color: {type: String, default: '--gray-500'},
    tooltip: {type: String, default: undefined},
    stroke: {type: String, default: undefined},
    teleported: {type: Boolean, default: false},
    strokeWidth: {type: [Number, String], default: 1}
  },
  computed: {
    c_stroke() {
      if (this.stroke) return this.stroke
      return `var(${this.color})`
    }
  }
}
